
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M3.67 2.5v11.97a3.121 3.121 0 001.25 2.5l5.21 3.9a3.135 3.135 0 003.75 0l5.21-3.9a3.121 3.121 0 001.25-2.5V2.5z","stroke":"#245389"}}),_c('path',{attrs:{"d":"M2 2.5h20","stroke":"#245389","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M8 8h8M8 13h8","stroke":"#f29030","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    